export default {
  INFO: 'info',
  SUCCESS: 'success',
  ERROR: 'error',
} as const;
